<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="450px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Zlecenia spedycyjne
                </h1>
            </v-card-title>


            <v-card-text class="pa-0">
                <v-container fluid class="px-6 py-2">
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :items="shippingOrders"
                                :mobile-breakpoint="0"
                                hide-default-footer
                                disable-pagination
                            >
                                <template #item.number="{item}">
                                    {{ item.number }}
                                </template>
                                <template #item.actions="{item}">
                                    <div class="d-inline-flex">
                                        <v-btn
                                            color="primary"
                                            depressed
                                            small
                                            data-sentry-label="Przejdź do ZS"
                                            @click="showShipmentsOrder(item)"
                                        >
                                            Przejdź
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <template>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Zamknij"
                        @click="onClose"
                    >
                        Zamknij
                    </v-btn>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ShipmentsOrdersDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        shippingOrders: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Numer ZS',
                    value: 'number',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'center',
                    width: 100,
                    sortable: false
                },
            ]
        }
    },
    methods: {
        showShipmentsOrder(shippingOrder) {
            this.$emit('show-shipping-order', shippingOrder)
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>
